// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SimpleHostingCreate-buttonContainer_raOLH","button":"SimpleHostingCreate-button_CXNiE","js-hidden":"SimpleHostingCreate-js-hidden_CO8nM"};